module.exports = __webpack_public_path__ + "static/media/6.33546b76.jpg";